/**
 * unique-url
 */
export const UniqueURL = (function () {

  var init =  function () {   
          
    events.addCopyButtonEventHandler();
    events.addQRCodeButtonEventHandler();
       
  }

  var events = {

    addCopyButtonEventHandler: function(){
      // Get any unique URL buttons 
      let buttons = document.getElementsByClassName("myds-invites-unique-invite-link-copy-button");
      Array.from(buttons).forEach(button => {
        // Add event listener to copy the input associated input to clipboard
        button.addEventListener('click', function (event) {
          event.preventDefault()
          var input = document.getElementById(button.dataset.input_id);
          navigator.clipboard.writeText(input.value);
          Util.toggleAlert('#myds-invites-unique-invite-link-alert', "<span class='font-weight-bold'>URL Copied!<span>" , 'alert-success', -1);
        }, false);
      });
    },

    addQRCodeButtonEventHandler: function(){
      // Get any unique URL buttons 
      let buttons = document.getElementsByClassName("myds-invites-unique-invite-link-qr-code-button");
      Array.from(buttons).forEach(button => {
        // Add event listener to copy the input associated input to clipboard
        button.addEventListener('click', function (event) {
          event.preventDefault();
          let qrCode = document.getElementById(this.id + '-download');
          let qrCodeURL = qrCode.src;
          console.log(qrCodeURL);

          // Create a temporary link element
          const link = document.createElement('a');
          link.href = qrCodeURL;

          const stringSplit = this.id.split("-");

          // Set the download attribute with a desired filename
          link.download = 'qr_code_' + stringSplit[2] + '.svg';

          // Append the link to the body (necessary for Firefox)
          document.body.appendChild(link);

          // Trigger the download by programmatically clicking the link
          link.click();

          // Remove the link from the document
          document.body.removeChild(link);
        }, false);
      });
    }
  }

  return {
    init: init,
    events: events
  }

}());


